/**
 *
 * @module dustServerPayload
 *
 */

import Check from 'check-types';
import InvalidArgumentException from '././../../exception/invalidArgumentException';

const {
    nonEmptyString,
    number,
    nonEmptyObject
} = Check.assert;

/**
 *
 * @class DustServerPayload
 * @since 3.4.0
 * @desc describes any relevant server information
 * @note if the dustEvent did not include a service call this will be unused
 *
 */
export default class DustServerPayload {

    /**
     *
     * @access private
     * @param {Object} options
     * @param {String} options.host
     * @param {String} options.path
     * @param {String} options.method
     * @param {Number} [options.statusCode]
     * @param {String} [options.requestId]
     * @param {Number} [options.roundTripTime]
     * @note unfortunately some services return an empty string for requestId
     * @throws {InvalidArgumentException}
     *
     */
    constructor(options = {}) {

        const errorMessage = {
            ctor: 'DustServerPayload(options)',
            get options() {
                return `${this.ctor} options should be a non-empty Object`;
            },
            get host() {
                return `${this.ctor} host should be a String with length`;
            },
            get path() {
                return `${this.ctor} path should be a String with length`;
            },
            get method() {
                return `${this.ctor} method should be a String with length`;
            },
            get statusCode() {
                return `${this.ctor} statusCode should be a Number`;
            },
            get requestId() {
                return `${this.ctor} requestId should be a String with length`;
            },
            get roundTripTime() {
                return `${this.ctor} roundTripTime should be a Number`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { host, path, method, statusCode, requestId, roundTripTime } = options;

        nonEmptyString(host, errorMessage.host, InvalidArgumentException);
        nonEmptyString(path, errorMessage.path, InvalidArgumentException);
        nonEmptyString(method, errorMessage.method, InvalidArgumentException);

        if (Check.assigned(statusCode)) {
            number(statusCode, errorMessage.statusCode, InvalidArgumentException);
        }

        if (Check.assigned(requestId)) {
            nonEmptyString(requestId, errorMessage.requestId, InvalidArgumentException);
        }

        if (Check.assigned(roundTripTime)) {
            number(roundTripTime, errorMessage.roundTripTime, InvalidArgumentException);
        }

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.host = host;

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.path = path;

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.method = method;

        /**
         *
         * @access private
         * @type {Number}
         *
         */
        this.statusCode = statusCode;

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.requestId = requestId;

        /**
         *
         * @access private
         * @type {Number}
         *
         */
        this.roundTripTime = roundTripTime;

    }

}



// WEBPACK FOOTER //
// ./src/services/internal/dust/dustServerPayload.js